import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import DepositRegistrationList from './components/DepositRegistrationList';

const { Cell } = ResponsiveGrid;

const DepositRegistration = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="寄物登記"
        breadcrumbs={[
          {
            name: '寄物管理',
          },
          {
            name: '寄物登記',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <DepositRegistrationList />
    </Cell>
  </ResponsiveGrid>
);

export default DepositRegistration;
